const Export = () => {
  return (
    <div className="flex flex-col p-6">
      {/* Setup Header */}
      <div className="mb-6">
        <p className="text-2xl text-[#EEEEEE] font-bold">Export</p>
      </div>
    </div>
  );
};

export default Export;
